import { iPaymentMethodBehaviour } from "@models/I_PaymentMethodBehaviour";

export const PaymentMethodConfig: iPaymentMethodBehaviour = {
  BANK_TRANSFER: {
    methodName: "TRANSF",
    behaviour: { name: "TRANSF", image: "transferLogo", track: "AccessToBankTransfer", isBank: false },
  },
  TRUE_LAYER: {
    methodName: "TrueLayer",
    behaviour: { name: "TrueLayer", image: "logo_truelayer", track: "AccessToTrueLayer", isBank: false },
  },
  EPG_MUCH_BETTER: {
    methodName: "MuchBetter",
    behaviour: { name: "MuchBetter", image: "logo_muchBetter", track: "AccessToEPGMuchBetter", isBank: false },
  },
  LOTBA: {
    methodName: "Lotba",
    behaviour: { name: "Lotba", image: "LOGOS LOTBA", track: "AccessToLotba", isBank: false },
  },
  PAYPAL: {
    methodName: "PAYPAL",
    behaviour: { name: "", image: "payPal", track: "AccessToPayPal", isBank: false },
  },
  LOCAL: {
    methodName: "LOCALCODERE",
    behaviour: { name: "Local Codere", image: "iconChargeLocal", track: "AccessToLocalDep", isBank: false },
  },
  COINS_PAID: {
    methodName: "COINSPAID",
    behaviour: { name: "Coinspaid", image: "Coinspaid", track: "AccessToCoinspaid", isBank: false },
  },
  EFECTY: {
    methodName: "EFECTY",
    behaviour: {
      // ACTUALLY USING DIMONEX (DimonexPayValidaCashPaymentMethodBehaviour) FOR EFECTY (so this behiour is not in use);
      name: "EEFECTY",
      image: "logo_payvalidacash",
      track: "AccessToPayValidaCash-Efecty",
      isBank: false,
    },
  },
  CROWN_CASINO_DEPOSIT: {
    methodName: "CrownCasinoDeposit",
    behaviour: {
      name: "CrownCasinoDeposit",
      image: "cs-logo_crown_casinos",
      track: "AccessToCrownCasinoDeposit",
      isBank: false,
    },
  },
  PAGUELO_FACIL: {
    methodName: "PAGUELOFACIL",
    behaviour: { name: "PAGUELOFACIL", image: "logo-paguelofacil", track: "AccessToPagueloFacil", isBank: false },
  },
  CVU_BANK: {
    methodName: "cvuBank",
    behaviour: { name: "cvuBank", image: "cvuLogo", track: "AccessToBankcvu", isBank: false },
  },
  T_PAGA_DEPOSIT: {
    methodName: "TPAGA-DEPOSIT",
    behaviour: { name: "TPAGA-DEPOSIT", image: "logo_Tpaga", track: "AccessToTpaga", isBank: false },
  },
  PAGOS_TRANS_360: {
    methodName: "PagosTrans360",
    behaviour: { name: "PagosTrans360", image: "logo_Trans360", track: "AccessToTransPagos360", isBank: false },
  },
  PAGOS_360: {
    methodName: "Pagos360",
    behaviour: { name: "Pagos360", image: "logo_Pagos360", track: "AccessToPagos360", isBank: false },
  },
  MERCADO_PAGO_REDIRECT_CARDS: {
    methodName: "MercadoPagoRedirectCards",
    behaviour: null, //MercadoPagoRedirectMethodBehaviour
  },
  MERCADO_PAGO_REDIRECT: {
    methodName: "MercadoPagoRedirect",
    behaviour: {
      name: "MercadoPagoRedirect",
      image: "logo_MercadoPago",
      track: "AccessToMercadoPago",
      isBank: false,
    },
  },
  MERCADO_PAGO_PRAXIS: {
    methodName: "MercadoPagoRedirect",
    behaviour: {
      name: "MercadoPagoRedirect",
      image: "logo_MercadoPago",
      track: "AccessToMercadoPago",
      isBank: false,
    },
  },
  MERCADO_PAGO: {
    methodName: "MercadoPago",
    behaviour: { name: "MercadoPago", image: "logo_MercadoPago", track: "AccessToMercadoPago", isBank: false },
  },
  OXXO_MASTERCARD: {
    methodName: "OxxoBank-MasterCard",
    behaviour: {
      name: "OxxoBank-MasterCard",
      image: "Logo_MasterCard",
      track: "AccessToOxxoMasterCard",
      documentNumberRequired: true,
    },
  },
  OXXO_VISA: {
    methodName: "OxxoBank-Visa",
    behaviour: {
      name: "OxxoBank-Visa",
      image: "Visa_epg",
      track: "AccessToOxxoVisa",
      documentNumberRequired: true,
    },
  },
  OXXO_BANCOLOMBIA: {
    methodName: "OxxoBank-Bancolombia",
    behaviour: {
      name: "OxxoBank-BanColombia",
      image: "banColombia",
      track: "AccessToOxxoBankColombia",
      documentNumberRequired: false,
    },
  },
  OXXO_CUCUTA: {
    methodName: "OxxoBank-Cucuta",
    behaviour: { name: "Cucuta", image: "logoto_cucuta", isBank: false, documentNumberRequired: false },
  },
  OXXO_PAGOTODO: {
    methodName: "OxxoBank-Pagotodo",
    behaviour: { name: "PagoTodo", image: "logo_pagoTodo", isBank: false, documentNumberRequired: false },
  },
  OXXO_ALMACENES_EXITO: {
    methodName: "OxxoBank-AlamacenesExitoBank",
    behaviour: {
      name: "OxxoBank-AlamacenesExitoBank",
      image: "almacenesExito",
      track: "AccessToOxxoBankAlmacenesExito",
      documentNumberRequired: false,
    },
  },
  OXXO_GANABANK: {
    methodName: "OxxoBank-GanaBank",
    behaviour: {
      name: "OxxoBank-GanaBank",
      image: "ganagana",
      track: "AccessToOxxoBankGana",
      documentNumberRequired: false,
    },
  },
  OXXO_CARULLA: {
    methodName: "carulla",
    behaviour: { name: "Carulla", image: "logo_carulla", isBank: false, documentNumberRequired: false },
  },
  OXXO_AZTECABANK: {
    methodName: "OxxoBank-AztecaBank",
    behaviour: { name: "OxxoBank-AztecaBank", image: "BancoAzteca", track: "AccessToOxxoAztecaBank" },
  },
  OXXO_GANA_CERCA: {
    methodName: "OxxoBank-GanaCercaBank",
    behaviour: {
      name: "OxxoBank-GanaCercaBank",
      image: "ganaCerca",
      track: "AccessToOxxoBankGanaCerca",
      documentNumberRequired: false,
    },
  },
  OXXO_TODITO: {
    methodName: "OxxoBank-Todito",
    behaviour: { name: "Todito", image: "Todito", isBank: false },
  },
  OXXO_BANORTE: {
    methodName: "OxxoBank-Banorte",
    behaviour: { name: "Banorte", image: "Banorte" },
  },
  OXXO_SANTANDER: {
    methodName: "OxxoBank-Santander",
    behaviour: { name: "Santander", image: "Santander" },
  },
  OXXO_BANAMEX: {
    methodName: "OxxoBank-Banamex",
    behaviour: { name: "Banamex", image: "Banamex" },
  },
  OXXO_BANCOMER: {
    methodName: "OxxoBank-Bancomer",
    behaviour: { name: "Bancomer", image: "Bancomer" },
  },
  OXXO_SPEI: {
    methodName: "OxxoBank-Spei",
    behaviour: { name: "ASTROSPI", image: "logo-spei", track: "AccessToSpei", isBank: false },
  },
  OXXO_DAVIPLATA_PSE: {
    methodName: "DaviplataPSE",
    behaviour: null, //PSEOxxoBankPaymentMethodBehaviour
  },
  OXXO_PSE: {
    methodName: "OxxoBank-PSE",
    behaviour: {
      name: "OxxoBank-PSE",
      image: "Spe",
      track: "AccessToOxxoPSE",
      documentNumberRequired: false,
      isBank: false,
    },
  },
  OXXO_BALOTO: {
    methodName: "OxxoBank-Baloto",
    behaviour: {
      name: "OxxoBank-Baloto",
      image: "logo-viabaloto",
      track: "AccessToOxxoBaloto",
      documentNumberRequired: false,
    },
  },
  OXXO_AMEX: {
    methodName: "OxxoBank-AmericanExpress",
    behaviour: {
      name: "OxxoBank-AmericanExpress",
      image: "AmericanExpress",
      track: "AccessToOxxoBankAmericanExpress",
    },
  },
  OXXO_CASH: {
    methodName: "OXXOCash",
    behaviour: { name: "OXXO", image: "logo-oxxo2", track: "AccessToOxxo", isBank: false },
  },
  OXXO_NEQUI_PSE: {
    methodName: "NequiPSE",
    behaviour: null, //PSEOxxoBankPaymentMethodBehaviour
  },
  OXXO_PAYNET: {
    methodName: "OxxoBank-Paynet",
    behaviour: { name: "PayNetOxxo", image: "PayNetOxxo", isBank: false },
  },
  VISA_BANCOMER: {
    methodName: "VisaBancomer",
    behaviour: { name: "BANCOMER", image: "bancomer0", track: "AccessToBancomer", isBank: false },
  },
  ASTROPAY_EPG: {
    methodName: "AstropayEPG",
    behaviour: { name: "AstropayEPG", image: "logo_astropayepg", track: "AccessToAstropayEPG", isBank: false },
  },
  PUNTO_PAGO: {
    methodName: "PUNTOPAGO",
    behaviour: { name: "Punto Pago", image: "puntoPagoLogo", track: "AccessToPuntoPago", isBank: false },
  },
  NETELLER: {
    methodName: "NETELLER",
    behaviour: { name: "APMNETELLER", image: "logo_netellerl", track: "AccessToNeteler", isBank: false },
  },
  RAPIDTRANSFER: {
    methodName: "RAPIDTRANSFER",
    behaviour: {
      name: "RAPIDTRANSFER",
      image: "logo_rapidTransfer",
      track: "AccessToRapidtransfer",
      isBank: false,
    },
  },
  CYBERSOURCE: {
    methodName: "CYBERSOURCE",
    behaviour: {
      name: "APMCYBERSOURCE",
      image: "cs-logo_CreditCards",
      track: "AccessToCyberSource",
      isBank: false,
    },
  },
  SKRILL: {
    methodName: "SKRILL",
    behaviour: { name: "APMSKRILL", image: "logo_skrill", track: "AccessToSKrill", isBank: false },
  },
  SKRILL_PRAXIS: {
    methodName: "SKRILL",
    behaviour: { name: "Skrill", image: "logo_skrill", track: "AccessToSKrill", isBank: false },
  },
  PAYNET: {
    methodName: "Paynet",
    behaviour: { name: "Paynet", image: "Paynet", track: "AccessToPaynet", isBank: false },
  },
  PAYUPSE: {
    methodName: "PAYUPSE",
    behaviour: null, //PayUPSEPaymentMethodBehaviour
  },
  PAYU: {
    methodName: "PAYU",
    behaviour: { name: "PayU", image: "PayU", track: "PayU", isBank: false },
  },
  PUNTORED: {
    methodName: "PUNTORED",
    behaviour: { name: "PUNTORED", image: "logo_payvalidacash", track: "AccessToPayValidaCash-Puntored" },
  },
  BALOTO: {
    methodName: "BALOTO",
    behaviour: { name: "BALOTO", image: "logo_payvalidacash", track: "AccessToPayValidaCash-Baloto" },
  },
  DIMONEX: {
    methodName: "",
    behaviour: { name: "Dimonex", image: "logo_payvalidacash", track: "AccessToPayValidaCash-Dimonex" },
  },
  TELEPAYCO: {
    methodName: "TELEPAYCO",
    behaviour: {
      name: "VISA",
      image: "Visa_Payment_icon",
      track: "AccessToCreditCardDepositTelepay",
      isBank: false,
    },
  },
  TELEINGRESOES: {
    methodName: "TELEINGRESOES",
    behaviour: { name: "TELEINGRESO", image: "teleingreso_logo", track: "AccessToTeleingreso" },
  },
  REDSYS_BIZUM: {
    methodName: "RedsysBizum",
    behaviour: { name: "Bizum", image: "bizum_trans", track: "AccessToBizum", isBank: false, form: true },
  },
  REDSYS_CARDS: {
    methodName: "RedsysCards",
    behaviour: { name: "RedsysCards", image: "Visa_epg", track: "AccessToRedsysCards", isBank: false },
  },
  BIZUM: {
    methodName: "Bizum",
    behaviour: { name: "Bizum", image: "bizum_trans", track: "AccessToBizum", isBank: false },
  },
  BIZUM_PRAXIS: {
    methodName: "Bizum",
    behaviour: { name: "Bizum", image: "bizum_trans", track: "AccessToBizum", isBank: false },
  },
  PAYSAFE: {
    methodName: "PAYSAFE",
    behaviour: { name: "PAYSAFE", image: "paySafe", track: "AccessToPaySafeCard", isBank: false },
  },
  EPG: {
    methodName: "EPG",
    behaviour: { name: "VISAEPG", image: "Visa_epg", track: "AccessToEPG", isBank: false },
  },
  TRANSFERENCIA: {
    methodName: "transferencia",
  },
  VISA_MASTERCARD: {
    methodName: "VISA/Mastercard",
  },
};
